import { SettingsIcon } from "@/components/atoms/icons";
import { ConfigPermission } from "@/config/models";

import { IGIREMenuItem } from "../../models/router.types";
import { PathNamekAppsRoutes, PathNamekRoutes } from "../../constants";

export const configMenuItems: IGIREMenuItem[] = [
  {
    label: "Configuración",
    icon: <SettingsIcon className="hover:fill-rdc-primary" size={20} />,
    data: PathNamekAppsRoutes.CONFIG,
    align: "end",
    permission: {
      must: [ConfigPermission.MATERIALS, ConfigPermission.ASSIGN_MATERIALS],
      exhaustive: false,
    },
    items: [
      {
        label: "Materiales",
        url: `/#/${PathNamekAppsRoutes.CONFIG}/${PathNamekRoutes.CONFIG.MATERIALS}`,
        permission: {
          must: ConfigPermission.MATERIALS,
        },
      },
      {
        label: "Asignación de materiales",
        url: `/#/${PathNamekAppsRoutes.CONFIG}/${PathNamekRoutes.CONFIG.ASSIGN_MATERIALS}`,
        permission: {
          must: ConfigPermission.ASSIGN_MATERIALS,
        },
      },
    ],
  },
];
